// eslint-disable-next-line no-extend-native
Array.prototype.unique = function (remove = true) {
  const duplicates = []
  const arr = this.sort() // input must be sorted for this to work
  for (let i = arr.length; i--;) {
    if (arr[i] === arr[i - 1]) {
      (remove) ? arr.splice(i, 1) : duplicates.push(arr[i])
    }
  }
  return (remove) ? arr : duplicates
}

// eslint-disable-next-line no-extend-native
Array.prototype.duplicates = function () {
  return this.unique(false)
}
